import React from "react";
import { PeekBox, PeekCheckbox, PeekFormControlLabel, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
export const ProductAccessSection = ({ isEnabled, onToggle, label, children }) => {
    const theme = useTheme();
    return (React.createElement(PeekStack, { spacing: 1 },
        React.createElement(PeekFormControlLabel, { control: React.createElement(PeekCheckbox, { size: "small", sx: {
                    p: 0.5,
                    mx: 0.3,
                } }), checked: isEnabled, onClick: onToggle, label: label, sx: {
                whiteSpace: "nowrap",
                ".MuiCheckbox-root": {
                    color: `${theme.palette.grey[400]} !important`,
                },
                ".Mui-checked": {
                    color: `${theme.palette.success.main} !important`,
                },
            } }),
        isEnabled && children && (React.createElement(PeekBox, { sx: {
                pl: 3,
                borderLeft: `2px solid ${theme.palette.grey[100]}`,
                ml: 1,
            } }, children))));
};
export default ProductAccessSection;
